import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from '@un-fao/lightforms-lib/lightforms-services';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css'],
    standalone: false
})
export class LogoutComponent implements OnInit 
{
  constructor(private configService: ConfigurationService) {};
  
  ngOnInit(): void {
    this.configService.logout();
    this.configService.user = null;
  }
}
